import { Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';

import { serviceurl } from 'src/app/constant/constant';
import { SKIP_ERROR_TOAST } from 'src/app/interceptors/error.interceptor';
import { Order } from './marketplace.models';
import { unwrapPage, Paginated } from './pagination.util';

@Injectable({ providedIn: 'root' })
export class OrderService {
  private apiUrl = serviceurl + 'api/v1/orders';

  constructor(private http: HttpClient) {}

  list(): Observable<Order[]> {
    // My Purchases shows its own "couldn't load" state with a retry button.
    return this.http.get<Paginated<Order> | Order[]>(`${this.apiUrl}/`, {
      context: new HttpContext().set(SKIP_ERROR_TOAST, true),
    }).pipe(unwrapPage<Order>());
  }

  get(id: number | string): Observable<Order> {
    return this.http.get<Order>(`${this.apiUrl}/${id}/`);
  }
}
